<template>
    <div data-view="strat.demo_request.v1" class="max pa-1">
        <v-layout row wrap py-10 class="hidden-xs-only">
            <v-flex xs12 md6 px-12 class="dr-info">
                <div class="dolo pr-8 dr-title">Request a Demo</div>
                <div class="roboto pr-8 font-weight-light dr-subtitle">Fill out this form to get in front of an <span class="font-weight-bold">Expert.</span></div>
                <div class="roboto text-uppercase grey--text t18">have a question?</div>
                <div class="roboto grey--text t18">
                Give us a call at
                <span class="font-weight-bold black--text ml-2">800.365.6522</span>
                </div>
            </v-flex>
            <v-flex xs12 md6>
                <v-form
                ref="reqDemoForm"
                v-model="valid"
                lazy-validation
                class="demo-req pr-12"
                >
                    <v-text-field
                        v-model="name"
                        :rules="nameRules"
                        label="Name"
                        required
                        class=""
                        clearable
                        height="54px"
                    ></v-text-field>

                    <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                        clearable
                        height="54px"
                    ></v-text-field>

                    <v-text-field
                        v-model="phone"
                        :rules="phoneRules"
                        label="Phone Number"
                        required
                        height="54px"
                        clearable
                    ></v-text-field>

                    <v-text-field
                        v-model="company"
                        :rules="compRules"
                        label="Company Name"
                        required
                        height="54px"
                        clearable
                    ></v-text-field>
                    <div class="dr-actions text-right mt-12">
                        <v-btn
                            text
                            class="mr-4"
                            @click="killReqDialog()"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            color="tertiary"
                            rounded
                            class="mr-4"
                            @click="submitReqDialog()"
                            :disabled="!valid"
                        >
                            Request Demo
                        </v-btn>
                    </div>
                </v-form>
                <div class="drd primary" :class="subSuccess ? 'active' : ''">
                    <div class="check white--text text-center">
                        <i class="las la-check-circle"></i>
                    </div>
                    <div class="message mb-12">
                        <div class="dolo nice tertiary--text text-center">Very Nice!</div>
                        <div class="roboto subtext amber--text text-center">An expert will be with you as soon as possible. Thank you for your time and interest.</div>
                    </div>
                    <div class="action text-center">
                        <v-btn rounded outlined color="white" @click="killReqDialogWithSuccess()">Close</v-btn>
                    </div>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="mobi hidden-sm-and-up">
            <v-card flat>
                <v-card-title class="px-4 dr-info">
                    <div class="dolo pr-6 dr-title" style="font-size: 1.5em; line-height: 40px;">Request a Demo</div>
                    <div class="roboto pr-8 t18 font-weight-light dr-subtitle" style="line-height: 21px; margin: 10px 0;">Fill out this form to get in front <br> of an <span class="font-weight-bold">Expert.</span></div>
                    <div class="roboto text-uppercase grey--text dr-dets pr-12">have a question?</div>
                    <div class="roboto grey--text text-center mt-n3 mr-12 dr-dets">
                        Give us a call at
                        <span class="font-weight-bold black--text ml-2 dr-dets">800.365.6522</span>
                    </div>
                </v-card-title>
                <v-card-text class="px-4 pt-0">
                    <v-form
                        ref="reqDemoForm"
                        v-model="valid"
                        lazy-validation
                        class="demo-req"
                    >
                        <v-text-field
                            v-model="name"
                            :rules="nameRules"
                            label="Name"
                            required
                            class=""
                            clearable
                            height="24px"
                        ></v-text-field>

                        <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="E-mail"
                            required
                            clearable
                            height="24px"
                        ></v-text-field>

                        <v-text-field
                            v-model="phone"
                            :rules="phoneRules"
                            label="Phone Number"
                            required
                            height="24px"
                            clearable
                        ></v-text-field>

                        <v-text-field
                            v-model="company"
                            :rules="compRules"
                            label="Company Name"
                            required
                            height="24px"
                            clearable
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                 <div class="dr-actions text-center mt-12">
                    <v-btn
                        text
                        class="mr-4 t12"
                        @click="killReqDialog()"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        color="tertiary"
                        rounded
                        class="t12"
                        @click="submitReqDialog()"
                        :disabled="!valid"
                    >
                        Request Demo
                    </v-btn>
                </div>
            </v-card>
            <div class="drd primary" :class="subSuccess ? 'active' : ''">
                <div class="check white--text text-center">
                    <i class="las la-check-circle" style="font-size: 100px; margin-bottom: 10px;"></i>
                </div>
                <div class="message mb-12">
                    <div class="dolo t32 tertiary--text text-center">Very Nice!</div>
                    <div class="roboto t14 amber--text text-center">An expert will be with you as soon as possible. Thank you for your time and interest.</div>
                </div>
                <div class="action text-center">
                    <v-btn rounded outlined color="white" @click="killReqDialogWithSuccess()">Close</v-btn>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data: () =>  {
        return {
            subSuccess: false,
            valid: false,
            name: '',
            nameRules: [
                v => !!v || 'Please enter your name before you submit this form.',
            ],
            phone: '',
            phoneRules: [
                v => !!v || 'Phone number is required',
                v => (v && v.length >= 10 && /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/) || 'Please enter a valid phone number.'
            ],
            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid.',
            ],
            company: '',
            compRules: [
                v => !!v || 'Please add your company name.',
            ],
        }
    },
    methods: {
        killReqDialog() {
            this.$emit('killReqDialog');
            this.name = ''
            this.phone = ''
            this.email = ''
            this.company = ''
            this.subSuccess = false
        },
        killReqDialogWithSuccess() {
            this.$emit('killReqDialog');
            this.name = ''
            this.phone = ''
            this.email = ''
            this.company = ''
        },
        submitReqDialog(){
            if(this.$refs.reqDemoForm.validate()) {
                const a = this.name+', '+this.phone+', '+this.email+', '+this.company
                //eslint-disable-next-line
                console.log('demo_request.methods.submitReqDialog -- data: '+a) 
                this.name = ''
                this.phone = ''
                this.email = ''
                this.company = ''
                this.subSuccess = true 
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .dr-info {
        .dr-title {
            font-size: 6em;
            line-height: 80px;
        }
        .dr-subtitle {
            line-height: 41px;
            margin: 60px 0;
            font-size: 40px;
        }

        .dr-dets {
            font-size: 12px;
        }
    }
    .dr-actions {
        position: absolute;
        width: 100%;
        bottom: 16px;
        right: 4px;
    }

    .drd {
        position: absolute;
        z-index: 1;
        bottom: 62px;
        right: 105px;
        height: 10px;
        width: 10px;
        z-index: 2;
        transition: all .37s;
        border-radius: 50%;
        opacity: 0;

        .check {
            margin-top: 0;
            transition: all .64s;
            opacity: 0;

            i {
                font-size: 240px;
                margin-bottom: 10px;
            }
        }

        .message {
            margin-left: 10%;
            transition: all .64s;
            opacity: 0;
            padding: 0 300px;

            .nice {
                font-size: 40px;
            }

            .subtext {
                font-size: 24px;
            }
        }

        .action {
            margin-top: 150px;
            transition: all .64s;
            opacity: 0;
        }

        &.active {
            border-radius: 0%;
            bottom: 0;
            right: 0;
            height: 100%;
            width: 100%;
            opacity: 1;

            .check {
                margin-top: 5%;
                opacity: 1;
                transition-delay: .34s
            }

            .message {
                margin-left: 0;
                opacity: 1;
                transition-delay: .54s
            }

            .action {
                margin-top: 0;
                opacity: 1;
                transition-delay: .64s
            }
        }
    }

    .demo-req{
        font-size: 22px;
        height: 170px;
        background-color: transparent !important;

        .v-input.dolo-tb input{
            background-color: transparent !important;
            caret-color: #ffc107;
            font-weight: bold !important;
            height: 170px !important;
            max-height: 170px !important;
            padding: 20px;
            line-height: 65px;
            font-size: 85px;
            text-align: center;
        }

        ::placeholder {
            font-size: 85px;
            font-weight: bold;
            color: darken(#efefef, 10%) !important;
        }
    }

    .tablet {
        .dr-info {
            margin-bottom: 160px;

            .dr-title {
                font-size: 2.5em;
                line-height: 40px;
            }
            .dr-subtitle {
                line-height: 24px;
                margin: 30px 0;
                font-size: 22px;
            }

            .dr-dets {
                font-size: 12px;
            }
        }
       .dr-actions {
            position: absolute;
            width: 100%;
            bottom: 16px;
            right: 4px;
        }
        .drd {
            position: absolute;
            z-index: 1;
            bottom: 62px;
            right: 105px;
            height: 10px;
            width: 100%;
            z-index: 2;
            transition: all .37s;
            border-radius: 50%;
            opacity: 0;

            .check {
                margin-top: 0;
                transition: all .64s;
                opacity: 0;

                i {
                    font-size: 140px;
                    margin-bottom: 10px;
                }
            }

            .message {
                margin-left: 10%;
                transition: all .64s;
                opacity: 0;
                padding: 0 100px;

                 .nice {
                    font-size: 32px;
                }

                .subtext {
                    font-size: 20px;
                }
            }

            .action {
                margin-top: 150px;
                transition: all .64s;
                opacity: 0;
            }

            &.active {
                border-radius: 0%;
                bottom: 0;
                right: 0;
                height: 100%;
                width: 100%;
                opacity: 1;

                .check {
                    margin-top: 5%;
                    opacity: 1;
                    transition-delay: .34s
                }

                .message {
                    margin-left: 0;
                    opacity: 1;
                    transition-delay: .54s
                }

                .action {
                    margin-top: 0;
                    opacity: 1;
                    transition-delay: .64s
                }
            }
        }

        .demo-req{
            font-size: 22px;
            height: 140px;
            background-color: transparent !important;

            .v-input.dolo-tb input{
                background-color: transparent !important;
                caret-color: #ffc107;
                font-weight: bold !important;
                height: 140px !important;
                max-height: 170px !important;
                padding: 20px;
                line-height: 65px;
                font-size: 85px;
                text-align: center;
            }

            ::placeholder {
                font-size: 85px;
                font-weight: bold;
                color: darken(#efefef, 10%) !important;
            }
        } 
    }

    .mobi {
        .dr-actions {
            position: fixed;
            width: 100%;
            bottom: 15px;
            right: 4px;
        }
        .drd {
            position: absolute;
            z-index: 1;
            bottom: 62px;
            right: 105px;
            height: 10px;
            width: 10px;
            z-index: 2;
            transition: all .37s;
            border-radius: 50%;
            opacity: 0;

            .check {
                margin-top: 0;
                transition: all .64s;
                opacity: 0;
            }

            .message {
                margin-left: 10%;
                transition: all .64s;
                opacity: 0;
                padding: 0 50px;
            }

            .action {
                margin-top: 150px;
                transition: all .64s;
                opacity: 0;
            }

            &.active {
                border-radius: 0%;
                bottom: 0;
                right: 0;
                height: 100%;
                width: 100%;
                opacity: 1;

                .check {
                    margin-top: 10%;
                    opacity: 1;
                    transition-delay: .34s
                }

                .message {
                    margin-left: 0;
                    opacity: 1;
                    transition-delay: .54s
                }

                .action {
                    margin-top: 0;
                    opacity: 1;
                    transition-delay: .64s
                }
            }
        }

        .demo-req{
            font-size: 22px;
            height: 170px;
            background-color: transparent !important;

            .v-input.dolo-tb input{
                background-color: transparent !important;
                caret-color: #ffc107;
                font-weight: bold !important;
                height: 170px !important;
                max-height: 170px !important;
                padding: 20px;
                line-height: 65px;
                font-size: 85px;
                text-align: center;
            }

            ::placeholder {
                font-size: 85px;
                font-weight: bold;
                color: darken(#efefef, 10%) !important;
            }
        }
    }
</style>